import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Flame } from "lucide-react";
import { api } from "../../lib/api";
import { avatarSrc } from "../../lib/avatars";

const MEDAL = ["text-amber-300", "text-slate-200", "text-orange-300"];

// Lobby: this week's Grinder top 3 in one slim strip; the whole strip opens the full board.
export const GrinderTopThree = () => {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => api.get("/api/leaderboard/grinder").then((r) => setRows(r.data.rows.slice(0, 3))).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  if (!rows) return null;
  return (
    <button type="button" data-testid="lobby-grinder-top3" onClick={() => nav("/leaderboard")}
      className="w-full gold-card rounded-2xl px-5 py-3 mb-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-left hover:border-amber-400/70 btn-lift">
      <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] gold-text"><Flame className="w-3.5 h-3.5" /> Weekly Grinder</span>
      {rows.length === 0 && <span className="text-xs text-slate-400">No one on the board yet — every hand you play counts.</span>}
      {rows.map((r, i) => (
        <span key={r.user_id} data-testid={`lobby-grinder-${i + 1}`} className="flex items-center gap-2">
          <span className={`font-display text-sm ${MEDAL[i]}`}>{i + 1}</span>
          <img src={avatarSrc(r.avatar)} alt="" className="w-6 h-6 rounded-full border border-white/10" />
          <span className="text-sm text-amber-50 max-w-[140px] truncate">{r.name}</span>
          <span className="font-mono text-xs text-slate-400">{r.points.toLocaleString()} pts</span>
        </span>
      ))}
      <span className="ml-auto flex items-center gap-1 text-xs text-slate-400">Full board <ChevronRight className="w-3.5 h-3.5" /></span>
    </button>
  );
};
